<template>
  <div class="b2b-menuList" v-if="listHotClass && listHotClass.length > 0">
    <el-tabs v-model="activeValue" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in listHotClass"
        :key="index"
        :label="item.ClassName"
        :name="menuList[index]"
      >
        <div
          class="list"
          v-if="listHotProducts.product && listHotProducts.product.length > 0"
        >
          <div
            class="product"
            v-for="(product, idx) in listHotProducts.product"
            :key="idx"
          >
            <div class="image" @click="toDetail(product.PId)">
              <el-image
                :src="imgUrlFilter(product.ProductCover)"
                fit="cover"
              ></el-image>
            </div>
            <div class="title">{{ product.ProductName }}</div>
            <div class="buttons">
              <el-button-group>
                <el-button
                  type="warning"
                  size="small"
                  class="basket-button"
                  @click="toBasket(product)"
                  >{{ $t("B2B.toBasket") }}</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  @click="toEnquiry(product)"
                  >{{ $t("B2B.inquiry") }}</el-button
                >
              </el-button-group>
            </div>
          </div>
        </div>
        <div v-else>
          <el-empty
            :description="$t('B2B.noData')"
            :image-size="100"
            style="text-align:center;"
          ></el-empty>
        </div>
        <div class="menu-pagination">
          <el-pagination
            :current-page="pageIndex"
            :page-sizes="[20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listHotProducts.totalCount"
            @size-change="sizeChange"
            @current-change="currentChange"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapMutations, mapActions } from "vuex";
import { SET_BASKET } from "../../../store/mutation-types";

export default {
  name: "MenuList",
  components: {},
  props: {
    active: {
      type: String,
      default: "1"
    },
    listHotClass: {
      type: Array
    },
    listHotProducts: {
      type: Object
    }
  },
  data() {
    return {
      menuList: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      activeValue: this.active,
      BPCId: "",
      pageIndex: 1,
      pageSize: 20
    };
  },
  methods: {
    ...mapMutations([SET_BASKET]),
    ...mapActions({ getBasketProducts: "getBasket" }),
    toBasket(val) {
      var product = {
        PId: val.PId,
        ProductName: val.ProductName,
        ProductImage: val.ProductCover,
        ShopId: val.ShopId,
        CompanyName: val.CompanyName
      };
      this.getBasketProducts().then(res => {
        var prduct = res.products.find(p => p.PId == val.PId);
        if (prduct) {
          this.$message.error(this.$t("B2B.repeat"));
        } else {
          this.$message.success(this.$t("B2B.addSuccess"));
          this.$bus.$emit("showBasket", { show: true, activeTab: "first" });
        }
        this.SET_BASKET({ product: product, type: 1 });
      });
    },
    toEnquiry(val) {
      let routeUrl = this.$router.resolve({
        path: "/enquiry",
        query: { PIdList: [val.PId] }
      });
      window.open(routeUrl.href, "_blank");
    },
    toDetail(productNumber) {
      let routeUrl = this.$router.resolve({
        path: "/commodity",
        query: { ProductNumber: productNumber }
      });
      window.open(routeUrl.href, "_blank");
    },
    sizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    currentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    getList() {
      this.$emit("loadMenuProduct", {
        BPCId: this.BPCId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    handleClick(tab) {
      var item = this.listHotClass[Number(tab.name) - 1];
      this.BPCId = item.BPCId;
      this.pageIndex = 1;
      this.pageSize = 20;
      this.getList();
    }
  }
};
</script>
<style lang="scss">
.b2b-menuList {
  background: rgb(246, 246, 246);
  padding-left: 10%;
  padding-bottom: 3%;
  .el-tabs__nav {
    margin-top: 3%;
    background: #fff;
    border: none !important;
  }
  .el-tabs__header {
    border: none !important;
    margin: 0;
  }
  .el-tabs__item {
    min-width: 205px;
    text-align: center;
    margin: 10px 10px 10px 0px;
    height: auto;
    line-height: 2;
    color: #000;
    background: transparent;
    border: 1px transparent !important;
  }
  .el-tabs__item:first-child {
    margin: 10px 10px 10px 10px !important;
  }
  .el-tabs__item.is-active {
    color: #fff;
    background: #01aaa3;
    border: 1px solid #01aaa3 !important;
  }
  .el-empty {
    margin-top: 10%;
    margin-bottom: 10%;
    .el-empty__image {
      margin: auto;
    }
    p {
      font-size: 14px;
      color: #999;
    }
  }
  .list {
    width: 90%;
    display: inline-block;
    overflow: hidden;
    .product {
      display: inline-block;
      margin-top: 2%;
      margin-right: 2%;
      border: 10px solid #fff;
      background: #fff;
      width: 18%;
      overflow: hidden;
      text-align: center;
      cursor: pointer;
      .image {
        background: rgb(244, 245, 246);
        vertical-align: middle;
        .el-image {
          width: 200px;
          height: 200px;
        }
      }
      .title {
        font-weight: bold;
        margin: 11px auto;
        padding: 0;
        width: 90%;
        font-size: 13px;
        line-height: 15px;
        height: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .buttons {
        .basket-button {
          background: linear-gradient(270.13deg, #f58603 0.13%, #fb3f04 99.91%);
        }
      }
    }
  }
  .menu-pagination {
    color: #777777;
    font-size: 10px;
    text-align: right;
    margin-top: 3%;
    margin-right: 12%;
  }
}
</style>
